import { action } from '../actions';

export const FETCH_COUNTRIES = 'FETCH_COUNTRIES';
export const REQUEST_COUNTRIES = 'REQUEST_COUNTRIES';
export const SUCCESS_COUNTRIES = 'SUCCESS_COUNTRIES';
export const FAILURE_COUNTRIES = 'FAILURE_COUNTRIES';

export const fetchCountries = () => action(FETCH_COUNTRIES);
export const requestCountries = () => action(REQUEST_COUNTRIES);
export const requestCountriesSuccess = (response: any) => action(SUCCESS_COUNTRIES, { response });
export const requestCountriesFailure = (error: any) => action(FAILURE_COUNTRIES, { error });
